import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFooter } from '@/stores/footerSlice'
import { RootState } from '@/stores'

export const useFooter = (show = true): boolean => {
  const dispatch = useDispatch()
  const footer = useSelector((state: RootState) => state.footer)
  useEffect(() => {
    dispatch(setFooter(show))
  }, [])
  return footer.show
}
